'use client';

import { PageWaitlistThankYouSchema } from '@/sanity/pages/PageWaitlistThankYouTemplate';
import Footer from '../global/partials/Footer';
import FAQSection from '../pageComponents/global/FAQSection';
import Link from 'next/dist/client/link';
import Logo from '../global/Logo';
import { PortableTextBlock } from 'next-sanity';
import Hero from '../pageComponents/waitlistThankYou/Hero';
import WhatHappensNow from '../pageComponents/waitlistThankYou/WhatHappensNow';
import SocialMedia from '../pageComponents/waitlistThankYou/SocialMedia';

export default function PageWaitlistThankYouJSX({
  data,
}: {
  data: PageWaitlistThankYouSchema;
}) {
  // Note: page_view / Active on Site is automatically tracked by Klaviyo script
  // The _kx parameter is automatically captured for attribution
  // No need to manually track - would create duplicates

  return (
    <main>
      <header className="absolute top-[6.19rem] lg:top-[4.87rem] w-full z-50">
        <div className="container flex flex-col lg:items-start items-center">
          <Link className="block" href="/" aria-label="Veylor">
            <Logo className="w-[9.64275rem] lg:w-[13.5rem]" />
          </Link>
        </div>
      </header>

      <Hero
        enableCountdown={data?.enableCountdown}
        label={data?.hero?.label}
        title={data?.hero?.title as PortableTextBlock[]}
        measuredRelease={data?.hero?.measuredRelease}
        numberOfPieces={data?.hero?.numberOfPieces}
        privateReleaseLink={data?.hero?.privateReleaseLink}
        countdownTime={data?.hero?.countdownTime}
      />

      <WhatHappensNow
        title={data?.whatHappensNow?.title}
        buttonMobile={data?.whatHappensNow?.buttonMobile}
        button={data?.whatHappensNow?.button}
        cards={data?.whatHappensNow?.cards}
      />

      <SocialMedia
        label={data?.socialMedia?.label}
        title={data?.socialMedia?.title}
        titleMobile={data?.socialMedia?.titleMobile as PortableTextBlock[]}
        socialLinks={data?.socialMedia?.socialLinks}
      />

      <FAQSection title={data?.faq?.title} faqs={data?.faq?.faqs} />

      {data?.settings?.footer && <Footer data={data?.settings?.footer} />}
    </main>
  );
}
